import { SxProps, Theme } from '@mui/material/styles';

// Shared styling for single-select YES/NO style toggle groups used across sections
export const SINGLE_SELECT_TOGGLE_SX: SxProps<Theme> = {
  backgroundColor: 'rgba(248, 250, 252, 1)',
  borderRadius: 1,
  padding: 0.5,
  border: '1px solid rgba(148, 163, 184, 0.4)',
  '& .MuiToggleButton-root': {
    textTransform: 'none',
    borderRadius: 0.75,
    border: '1px solid transparent',
    px: 1.5,
    py: 0.25,
    fontWeight: 500,
    color: 'rgba(55, 65, 81, 0.9)',
    backgroundColor: 'rgba(148, 163, 184, 0.12)',
    '&.Mui-selected': {
      backgroundColor: 'primary.main',
      color: 'primary.contrastText',
      borderColor: 'primary.main',
      boxShadow: '0 2px 6px rgba(15, 23, 42, 0.18)',
      ':hover': {
        backgroundColor: 'primary.main',
      },
    },
    '&:not(.Mui-selected):hover': {
      backgroundColor: 'rgba(148, 163, 184, 0.2)',
    },
  },
};

// Shared styling for multi-select pill groups with checkmarks
export const MULTI_SELECT_TOGGLE_SX: SxProps<Theme> = {
  gap: 1,
  '& .MuiToggleButton-root': {
    textTransform: 'none',
    borderRadius: '999px',
    px: 2,
    py: 0.5,
    border: '1px solid',
    borderColor: 'divider',
    backgroundColor: 'background.paper',
    fontWeight: 500,
    '&.Mui-selected': {
      backgroundColor: 'primary.main',
      color: 'primary.contrastText',
      borderColor: 'primary.main',
      boxShadow: '0px 4px 10px rgba(15, 23, 42, 0.25)',
      '&:hover': {
        // Slightly lighter version of primary for hover on selected pills
        backgroundColor: 'primary.main',
      },
    },
    '&:not(.Mui-selected):hover': {
      backgroundColor: 'action.hover',
    },
  },
};

// Shared styling for "Show/Hide last month" inline chip button
export const LAST_MONTH_TOGGLE_BUTTON_SX: SxProps<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 0.5,
  cursor: 'pointer',
  color: 'text.secondary',
  ml: 0.5,
  px: 0.25,
  py: 0.25,
  borderRadius: 999,
  '&:hover': {
    backgroundColor: 'transparent',
    color: 'text.primary',
  },
};

// Width of the delete-icon spacer used to align multi-row field content with single-row fields
export const DELETE_ICON_SPACER_WIDTH = 30;
// Width of the bookmark-icon spacer used to align field content when no bookmark is shown
export const BOOKMARK_ICON_SPACER_WIDTH = 24;
// Combined spacer for rows that reserve space for both delete and bookmark icons
export const DELETE_AND_BOOKMARK_SPACER_WIDTH = DELETE_ICON_SPACER_WIDTH + BOOKMARK_ICON_SPACER_WIDTH;
